import {
    FILTRO_SALDOS_COBRAR_CONTABILIDAD,
} from '../../types'


export default (state, action) => {
    switch (action.type){
        case FILTRO_SALDOS_COBRAR_CONTABILIDAD:
            return{
                ...state, 
                filtroSaldosPorCobrarContabilidad: action.payload
            }
        default:
            return state
    }
        
}